import { css } from "@tento-ui/component-styles";
import { ChatThemes } from "../chat/chat-theme";
import type { ChatTheme } from "../chat/chat-theme";
import { AnthropicLook } from "../chat/looks/anthropic";
import { ChatGptLook } from "../chat/looks/chatgpt";
import { ClaudeCliLook } from "../chat/looks/claude-cli";
import { CodexLook } from "../chat/looks/codex";
import { IMessageLook } from "../chat/looks/imessage";

// The wardrobe for the playground (`dev/chat-playground.ts`). The product-replica
// looks — iMessage, ChatGPT, Anthropic, Codex, Claude CLI — are library
// primitives (@tento-ui components/chat/looks/*, one researched replica per
// file); this file only arranges them for the playground and adds its one
// developer-only look.
export namespace ChatLooks {
  export interface Look {
    label: string;
    theme: ChatTheme;
  }

  // The developer look: the debug register on a plain workbench ground —
  // every turn is its ChatMessage, printed. The register carries its own
  // monospace face; the sheet only sets the ground and breathing room. A
  // debug workbench is playground furniture, not a product replica, so it
  // stays here rather than joining the library wardrobe.
  const debugJson: ChatTheme = {
    ...ChatThemes.debug(),
    name: "debug-json",
    $style: css`
      :host {
        background: #f6f8fa;
        --thread-top-inset: 12px;
        --thread-bottom-inset: 12px;
        --chat-turn-inset: 16px;
      }
    `,
  };

  export const all: Look[] = [
    { label: "iMessage", theme: IMessageLook },
    { label: "ChatGPT", theme: ChatGptLook },
    { label: "Anthropic", theme: AnthropicLook },
    { label: "Codex", theme: CodexLook },
    { label: "Claude CLI", theme: ClaudeCliLook },
    { label: "Debug JSON", theme: debugJson },
  ];
}
